import styled from 'styled-components'

// Expandable/collapsable div
const Content = styled.div<ContentProps>`
  padding-top: 18px;
  padding-right: 20px;
  padding-bottom: 18px;
  padding-left: 20px;
  ${({ collapse }) => collapse ? `
    display: none;
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    animation: close .5s ease 1;
  ` : `
    display: block;
    overflow: visible;
    max-height: auto;
    opacity: 1;
    animation: open .5s ease 1;
  `}
  background: #FAFAFA;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #E1E1E1;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #E1E1E1;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #E1E1E1;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;

  @keyframes open {
    from {
      max-height: 0;
      opacity: 0;
    }
    to {
      max-height: 100%;
      opacity: 1;
    }
  }

  @keyframes close {
    from {
      max-height: 100%;
      opacity: 1;
    }
    to {
      max-height: 0;
      opacity: 0;
    }
  }
`

export default Content

export interface ContentProps {
  collapse: boolean
}
